export default {
    'loyalty': 'الولاء',
    'religion': 'الديانة',
    'personality': 'الشخصية',
    'birthdate': 'تاريخ ميلاد العميل',
    'weekend': 'العطلة ',
    'near-by-pharmacies-one': '',
    'nearbyPharmaciesTwo': '',
    'works-in-centers': 'من يعمل في المركز ',
    'work-hour-from': 'تبدأ ساعات العمل من ',
    'work-hour-to': 'تنتهي ساعات العمل في',
    // config translate
    'doctorHobbies': 'هوايات العميل',
    'visit-notes': 'ملاحظات الزيارة',
    // config translate
    'pharmacist-info': 'معلومات عن الصيدلي',
    // config translate
    'pharmacy-info': 'معلومات الصيدلية',
    // 'doctor-filter-in-customer-interface': '',
    // config translate
    'doctorNames': 'اسماء الموظفين',
    'specialty': 'التخصص',
    'unavailable-materials': 'المواد الغير متوفرة',
    'competitive-samples': 'المواد التنافسية',
    // config translate
    'center-notes': 'ملاحظات المركز',

    'phone-number': 'رقم الموبايل',
    'landline-number': 'رقم الأرضي',
    'address': 'العنوان',
    'email': 'البريد الإلكتروني',
    'job-position': 'المنصب الوظيفي',
    'facebook-profile-url': 'رابط البروفايل على فيس بوك',
    'starting-date': 'تاريخ البدء',
    'line-manager': 'المدير المباشر',
    'role': 'الدور الوظيفي',
    'gender': 'الجنس',
    'regions': 'المناطق',
    'team': 'الفرق',
    'leave-days-number': 'عدد أيام الإجازة المسموح',   
    'username': 'اسم المستخدم',
    'password': 'كلمة المرور',
    'certificate': 'الشهادة',
    'target-value': 'معدل الزيارات',
    'financial-target-value': 'المعدل المالي للمندوب',
    'employee-type': 'نوع الموظف (مندوب أو إداري)',
    'leaves': 'الإجاات',
    'add-leaves-for-staff': 'إضافة إجازات لموظفين',
    'manage-leave-balances': 'إدارة معدل الإجازات',
    'generate-materials': 'توليد المواد',
    'material-transactions': 'مناقلات المواد',
    'rep-plan': 'خطة مندوب',
    'rep-visits': 'زيارات مندوب',
    'weekly-reports': 'التقارير الأسبوعية',
    'monthly-plan-reports': 'تقارير الخطة الشهرية',
    'reviews': 'مراجعات',
    'exams': 'اختبارات',
    'salaries': 'الرواتب',
    'rep': 'مندوب',
    'entities': 'جهات',
    'entity-modification-requests': 'طلبات تعديل جهة',
    'charts': 'مخططات',
    'users': 'مستخدمين',
    'roles': 'الأدوار', 
    'general-filter': 'فلاتر عامة',
    'manage-team': 'إدارة الفرق',
    'entity': 'الجهة',
    'free-sample': 'عينات مجانية',
    'other-samples': 'عينات أخرى',
    'notes': 'ملاحظات',
    'objections': 'الاعتراضات',
    'next-visit-notes': 'ملاحظات الزيارة التالية',
    'purpose': 'الهدف',
    'material-amount': 'كمية المادة',
    'unavailable-material': 'المواد الغير متوفرة',
    'core-message': 'الرسالة الأساسية',
    'longitude': 'خطوط الطول (من أجل العرض في الخريطة)',
    'latitude': 'خطوط العرض (من أجل العرض في الخريطة)',
    'duration-in-minutes': 'المدة بالدقايق',
    'amount-received': 'المبلغ المستلم',
    'residentDoctorNames': 'أسماء الموظفين الموجودين',
    'payment': 'طريقة الدفع ',
    'price-type': 'نوع السعر',
    number: 'الرقم',
    'name': 'الاسم',
    'material-form': 'شكل المادة',
    description: 'الوصف',
    'dose': 'الجرعة',
    'strength': 'التركيز',
    // config
    'pills-per-box': 'العدد في العلبة',
    'price': 'السعر',
    'leaflet-file-path': 'مسار الرابط',
    'min-amount': 'الحد الأدنى ',
    'max-amount': 'الحد الأعلى',
    'composition-per-unit': 'التركيب لكل حبة',
    'pharmacies-price': 'سعر الصيدلية',
    'price-types': 'أنواع الأسعار',
    'price-discount-rate': 'نسبة الحسم',
    'please-select-a-section': 'الرجاء اختيار القسم',

    // 'type': 'نوع الزبون',
    // 'entity-type': '',
    'best-time-to-visit': 'أفضل وقت لزيارة العميل',
    'opening-time': 'مفتوح من',
    'closing-time': 'مغلق',
    // 'resident-doctor-names': 'أسماء الأطباء المقيمين',
    'contact-info': 'معلومات التواصل',
    'personal-note': 'ملاحظة شخصية',
    'doctor-hobbies': 'هوايات الزبون',
    'near-by-pharmacies': 'الصيدليات القريبة',
    'work-hours-to': 'ساعات العمل إلى ',
    'work-hours-from': 'ساعات العمل من',
    'resident-doctor-names': 'كادر العمل',
    'type': 'النوع',
    'material-amounts': 'كمية المادة'
}